module.exports = __webpack_public_path__ + "img/trinity.d87739d6.png";